<template>
  <button
    class="inline-flex items-center transition ease-in duration-200 uppercase rounded-full hover:bg-gray-800 hover:text-white border-2 border-gray-900 focus:outline-none"
  >
    <slot name="icon" />
    <slot />
  </button>
</template>
